// TODO: refactor this component
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { Button, Input, Col, notification, Row, Table } from "antd";
import {
   CloudDownloadOutlined,
   SearchOutlined,
   DownloadOutlined,
   FilePdfOutlined
} from "@ant-design/icons";
import { httpService } from "../../base/services/httpService.service";
import AuthService from "../../base/services/authentication.service";
import { formatDate } from "../../helpers/formatDate";
import { getStatusClassName } from "../../helpers/statusClassNames";
import https from "../../base/utils/http";
import ActionsIcons from "../../ui/ActionsIcons/ActionsIcons";

import "./index.scss";

const BillingHistory = React.memo(() => {
   const organizationId = AuthService.getOrganizationId();
   const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
   const [searchText, setSearchText] = useState("");
   const [isLoading, setIsLoading] = useState("");
   const [billingHistory, setBillingHistory] = useState([]);

   const fetchData = useCallback(() => {
      setIsLoading("fetchingData");
      httpService
         .get(
            `/Payment/getStripeInvoicesDetailsByOrganizationUser?organizationId=${organizationId}`,
            (response) => {
               const formattedData = response.data.map((item) => ({
                  ...item,
                  id: item.invoiceId,
                  key: item.invoiceId,
                  start: formatDate(item.billingPeriodStart),
                  end: formatDate(item.billingPeriodEnd)
               }));
               setBillingHistory(formattedData);
            }
         )
         .finally(() => {
            setIsLoading("");
         });
   }, [organizationId]);

   useEffect(() => {
      fetchData();
   }, []);

   const handlePagination = (page, pageSize) => {
      setPagination({ ...pagination, current: page, pageSize });
   };

   const handleSearch = useCallback(
      (e) => {
         setSearchText(e.target.value);

         setPagination({ ...pagination, current: 1 });
      },
      [searchText]
   );

   const filteredDataSource = billingHistory?.filter((item) => {
      if (!searchText) return item;
      return Object.values(item).some(
         (val) =>
            val &&
            val
               .toString()
               .toLowerCase()
               .includes(searchText.toLowerCase())
      );
   });

   const columns = [
      {
         title: "File name",
         dataIndex: "fileName",
         key: "fileName",
         width: 300,
         render: (text, render) => (
            <div
               style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  cursor: "pointer"
               }}
            >
               <div
                  style={{
                     fontSize: "18px"
                  }}
               >
                  <FilePdfOutlined />
               </div>
               {text}
            </div>
         )
      },
      {
         title: "Start",
         dataIndex: "start",
         key: "start",
         width: 150
      },
      {
         title: "End",
         dataIndex: "end",
         key: "end",
         width: 150
      },
      {
         title: "Amount paid",
         dataIndex: "amountDue",
         key: "amountDue",
         width: 150
      },
      {
         title: "Status",
         dataIndex: "paymentStatus",
         key: "paymentStatus",
         width: 100,
         render: (text, record) => {
            return <p className={`status ${getStatusClassName(text)}`}>{text}</p>;
         }
      }
   ];

   const downloadFileColumn = {
      key: "previewDownload",
      fixed: "right",
      width: "80px",
      render: (text, render) => (
         <ActionsIcons
            actions={[
               {
                  icon: <CloudDownloadOutlined />,
                  tooltip: "Download",
                  // link: render.pdf,
                  disabled: isLoading === "downloadingAll",
                  onClick: (e) => {
                     e.stopPropagation();
                     console.log("render.pdf:", render.pdf);
                     window.open(render.pdf, "_blank");
                  }
               }
            ]}
         />
      )
   };

   const handleDownloadAll = async () => {
      setIsLoading("downloadingAll");
      try {
         const params = new URLSearchParams({ organizationId });

         const res = await https.get(
            `/Payment/downloadAllStripeInvoicesForOrganization?${params.toString()}`,
            { responseType: "blob" }
         );

         if (res.data.size === 0) {
            throw new Error("Received empty file.");
         }

         const blob = new Blob([res.data], { type: "application/zip" });
         const link = document.createElement("a");
         link.href = window.URL.createObjectURL(blob);
         link.download = "Invoices.zip";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);

         notification.success({
            message: "Invoices downloaded successfully!"
         });
      } catch (error) {
         console.error("Download error:", error);
         notification.error({
            message: "Error downloading invoices, please try again later."
         });
      } finally {
         setIsLoading("");
      }
   };

   return (
      <>
         <div className="billingHistory accountSettings">
            <Row gutter={16} className="billingHistory_header mb-8">
               <Col xs={24} sm={18} lg={12} xl={12}>
                  <span className="title">Billing history</span>
               </Col>
               <Col
                  xs={24}
                  sm={6}
                  lg={12}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
               >
                  <Button
                     type="default"
                     className="primaryButton"
                     onClick={handleDownloadAll}
                     loading={isLoading === "downloadingAll" || isLoading === "fetchingData"}
                     icon={<DownloadOutlined />}
                  >
                     Download all
                  </Button>
               </Col>
            </Row>
            <Row className="search mt-8 mb-8">
               <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                  <Input placeholder="Search" onChange={handleSearch} suffix={<SearchOutlined />} />
               </Col>
            </Row>
            <Table
               prefixCls="table-section"
               dataSource={filteredDataSource}
               columns={[...columns, downloadFileColumn]}
               scroll={{
                  x: 1100,
                  y: 600
               }}
               pagination={{
                  ...pagination,
                  position: ["bottomRight"],
                  showSizeChanger: false,
                  onChange: (page, pageSize) => {
                     handlePagination(page, pageSize);
                  }
               }}
               loading={isLoading === "fetchingData"}
            ></Table>
         </div>
      </>
   );
});

export default BillingHistory;
